export default __webpack_public_path__ + "static/media/jekfolio.7ff6ea3c.svg";